<div class="timestamp-container">
    <!-- Date Picker -->
    <mat-form-field appearance="outline" class="example-form-field" *ngIf="isEditMode()">
        <mat-label>{{data.columnName}}</mat-label>
        <input matInput [matDatepicker]="datepicker"  [(ngModel)]="inputValue" (dateChange)="onDateChange($event)">
        <mat-hint>MM/DD/YYYY</mat-hint>
        <mat-datepicker-toggle matSuffix [for]="datepicker"></mat-datepicker-toggle>
        <mat-datepicker #datepicker>
        </mat-datepicker>
    </mat-form-field>

    <!-- Time Selector -->
    <mat-form-field appearance="outline" *ngIf="isEditMode()">
        <mat-label>Select Time</mat-label>
        <mat-select [(ngModel)]="selectedTime" (selectionChange)="updateTimeSelection($event.value)">
        <mat-option *ngFor="let time of times" [value]="time">{{ time }}</mat-option>
        </mat-select>
    </mat-form-field>

    <mat-label *ngIf="!timestamp && !isEditMode()" style="font-size: 10px;">{{data.columnName}}</mat-label>
    <mat-chip-list *ngIf="!isEditMode()" class="chip-edit" >
      <mat-chip *ngIf="timestamp" class="chip-edit" color="primary" selected (click)="switchEditingMode()"> 
        {{timestamp}}
      </mat-chip>
      <mat-chip (click)="switchEditingMode()" *ngIf="!timestamp"> 
        {{data.columnName}}: 
      </mat-chip>
    </mat-chip-list>
    
    <i class="fas fa-solid fa-angle-up icon" *ngIf="isEditMode()" (click)="switchEditingMode()"></i>
  </div>

